export default __webpack_public_path__ + "src/assets/icn-connect-trezor-new.5f46486c045a1c353f24313b4715db62.svg";